//
//
//
//
//
//

export default {
  name: 'qrcode',
  data() {
    return {
      main_height: "",
    }
  },
  mounted() {
    this.$store.dispatch("titleAction", "名片二维码");
    this.$nextTick(() => {
      this.main_height = `${document.documentElement.clientHeight}`;
      this.$refs.iframe.style.height = (parseInt(this.main_height) - 45) + "px";
    })

  },
  methods: {},
  components: {}
}



// WEBPACK FOOTER //
// ./src/components/qrcode.vue